import InvestmentListItem from "./InvestmentListItem";

export default InvestmentListItem;